import { Image, Box } from "@chakra-ui/react";
import { ReviewCard } from "modules/common/components";
import type { TrustpilotTestimonialCardProps } from "../TrustpilotTestimonial.d";

export const TrustpilotTestimonialMobile = ({ imageProps, review, sbEditable }: TrustpilotTestimonialCardProps) => (
  <Box borderRadius="xl" overflow="hidden" {...sbEditable}>
    <Image {...imageProps} maxHeight="436px" objectFit="cover" />
    <ReviewCard review={review} borderColor="greyscale.100" boxShadow="alt" borderTopRadius="none" />
  </Box>
);
